// Components
import { Button, IconFacebook, IconExclamationCircle } from '@tracklib/kit'

// Hooks
import { useRequest } from 'modules/requests/hooks'

import styles from './socialauthform.css'

type SocialAuthFormProps = {
  showOr?: boolean
  socialError?: string
  signup?: boolean
  handleClick: (provider: 'facebook') => Promise<Record<string, unknown>>
}

const SocialAuthForm = ({ showOr = true, socialError, handleClick, signup }: SocialAuthFormProps): JSX.Element => {
  const fetchFBrequest = useRequest('FETCH_FACEBOOK_SDK')
  return (
    <div>
      <div className={styles.container}>
        <Button
          onClick={() => handleClick('facebook')}
          isLoading={fetchFBrequest.isLoading}
          disabled={fetchFBrequest.isLoading}
          className={styles.facebook}
        >
          <IconFacebook />
          {signup ? 'Sign up' : 'Login'} with Facebook
        </Button>
      </div>
      {socialError && (
        <div className={styles.error}>
          <IconExclamationCircle className={styles.errorIcon} />
          <span className={styles.errorMessage}>{socialError}</span>
        </div>
      )}
      {showOr && <hr className={styles.or} data-content="or" />}
    </div>
  )
}

export default SocialAuthForm
